import Map from 'ol/Map'
import View from 'ol/View'
import { jsPDF as JsPDF } from 'jspdf'
import { he } from 'date-fns/locale'
import domtoimage from 'dom-to-image'

export function useMapExport(
  mapWrapper: Ref<{
    map: Map
  }>
) {
  const router = useRouter()
  function exportToPng() {
    console.log('exportToPng', router.currentRoute.value.path)
    const fileName = `Drivmedla${router.currentRoute.value.path.replace(/^\/(.*?\/)/, '/$1')}.png`
    const size = mapWrapper.value.map.getSize()
    if (!size) return
    const viewResolution = mapWrapper.value.map.getView().getResolution()
    const pixelRatio = window.devicePixelRatio
    const width = size[0] * pixelRatio
    const height = size[1] * pixelRatio
    mapWrapper.value.map.once('rendercomplete', function () {
      const mapCanvas = document.createElement('canvas')
      mapCanvas.width = width
      mapCanvas.height = height
      const mapContext = mapCanvas.getContext('2d')
      if (!mapContext) return
      Array.prototype.forEach.call(
        document.querySelectorAll('.ol-layers canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity || canvas.style.opacity
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity)
            const backgroundColor = canvas.parentNode.style.backgroundColor
            if (backgroundColor) {
              mapContext.fillStyle = backgroundColor
              mapContext.fillRect(0, 0, canvas.width, canvas.height)
            }
            mapContext.drawImage(canvas, 0, 0)
          }
        }
      )
      mapContext.globalAlpha = 1
      mapContext.setTransform(1, 0, 0, 1, 0, 0)
      const link = document.createElement('a')
      link.href = mapCanvas.toDataURL()
      link.setAttribute('download', fileName)
      link.click()

      // Reset original map size
      mapWrapper.value.map.setSize(size)
      mapWrapper.value.map.getView().setResolution(viewResolution)
    })
    mapWrapper.value.map.renderSync()
  }
  return { exportToPng }
}
